module.exports = __webpack_public_path__ + "static/img/commodity_back.6907ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commodity_back.png
// module id = wvdR
// module chunks = 128